var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-3xl md:text-4xl",class:_vm.classStyles['text-secondary_color-500']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }